<template>
    <div>
       <DataTable :datatable="items" :header="headers" @page-changed="pageChange($event)">
           <template v-slot:table-slot>
               <div class="w-full grid gap-5 grid-cols-[1fr_auto]">
                   <form @submit.prevent action="" class="w-full">
                       <div class="flex border-b-2 bg-gray-100 border-gray-300 dark:bg-gray-900 dark:text-gray-100 dark:border-gray-800 focus:outline-none py-1 mb-4 w-full text-gray-700 font-medium">
                           <input type="text" class="focus:outline-none bg-transparent w-full" placeholder="Search..." v-model="search">
                           <mdicon name="magnify" size="28" class="mr-1 text-gray-700 dark:text-gray-100"/>
                       </div>
                    </form>

                    <button class="text-sm font-medium focus:outline-none active:translate-y-[2px] duration-200 bg-primary inline-block relative h-8 rounded shadow w-16 text-center text-gray-100" @click="addModal" v-if="isCreatePermitted">Add</button>
               </div>
           </template>

           <template v-slot:action="item">
                <div class="flex">
                   <button class="flex justify-center items-center bg-danger mr-2 px-2 py-1 text-gray-100 rounded text-xs font-medium focus:outline-none" @click="resetpass(item)" v-if="isUpdatePermitted"><mdicon name="pencil" class="text-gray-100 mr-[2px]" size="15"/><span>Reset</span></button>
                   <button class="flex justify-center items-center bg-primary mr-2 px-2 py-1 text-gray-100 rounded text-xs font-medium focus:outline-none" @click="editModal(item)" v-if="isUpdatePermitted"><mdicon name="pencil" class="text-gray-100 mr-[2px]" size="15"/><span>Edit</span></button>
                   <button class="flex justify-center items-center bg-secondary px-2 py-1 text-gray-100 rounded text-xs font-medium focus:outline-none" @click="deleteModal(item)" v-if="isDeletePermitted"><mdicon name="trash-can-outline" class="text-gray-100 mr-[2px]" size="15"/><span>Delete</span></button>
               </div>
           </template>
       </DataTable>
       <FormBase v-if="modal" @closeModal="modal = !modal">
            <template v-slot:formName>
               {{title}}
            </template>
            <template v-slot:form>
                <div class="mb-10 grid gap-5 grid-cols-2">
                    <div class="form-group">
                        <input type="text" placeholder="Name" class="w-full border-b border-gray-400 dark:border-gray-800 dark:text-gray-100 bg-transparent focus:outline-none py-2 px-2 text-sm font-normal text-gray-700" v-model="form.name">
                    </div>
                    <div class="form-group">
                        <input type="text" placeholder="Email" class="w-full border-b border-gray-400 bg-transparent dark:border-gray-800 dark:text-gray-100 focus:outline-none py-2 px-2 text-sm font-normal text-gray-700"  v-model="form.email">
                    </div>                    
                </div>
                <div class="grid gap-5 mb-10" :class="editIndex == -1 ? 'grid-cols-2':'grid-cols-1'">
                   <div class="form-group">
                        <select name="" id="" v-model="form.role_id" class="w-full border-b border-gray-400 bg-transparent dark:border-gray-800 dark:text-gray-100 focus:outline-none py-2 px-2 text-sm font-normal text-gray-700">
                            <option value="" class="dark:bg-gray-900 dark:text-gray-100">Pilih Role</option>
                            <option v-for="r in roles" :key="r.id" :value="r.id" class="dark:bg-gray-900 dark:text-gray-100">{{r.role}}</option>
                        </select>
                    </div>
                    <div class="form-group">        
                        <div class="form-group" v-if="editIndex == '-1'">
                            <input type="password" placeholder="Password" class="w-full border-b border-gray-400 bg-transparent dark:border-gray-800 dark:text-gray-100 focus:outline-none py-2 px-2 text-sm font-normal text-gray-700"  v-model="form.password">
                        </div>
                    </div>
                </div>

                 <div class="form-group flex flex-col">
                    <label for="" class="text-sm font-medium text-gray-500 dark:text-gray-100">Foto</label>
                    <input type="file" name="" id="" @change="selectImage($event)">
                </div>
            </template>
             <template v-slot:formFooter>
                  <div class="text-primary dark:text-gray-100 font-medium text-lg cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-100 py-2 px-4 rounded" @click="modal = !modal">
                      Cancel
                  </div> 
                   <div class="text-primary dark:text-gray-100 font-medium text-lg cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-100 py-2 px-4 rounded" @click="save">
                      Save
                  </div>                        
            </template>
       </FormBase>
       <FormBase v-if="resetmodal" @closeModal="resetmodal = !resetmodal">
                    <template v-slot:formName>
                    {{title}}
                    </template>
                    <template v-slot:form>
                        <div class="mb-10 grid gap-3 grid-cols-1">
                            <div class="form-group mb-5">
                                <input type="password" placeholder="New Password" class="w-full border-b border-gray-400 dark:border-gray-800 dark:text-gray-100 bg-transparent focus:outline-none py-2 px-2 text-sm font-normal text-gray-700" v-model="formpass.newpass">
                            </div>   
                            <div class="form-group">
                                <input type="password" placeholder="Confirm Password" class="w-full border-b border-gray-400 dark:border-gray-800 dark:text-gray-100 bg-transparent focus:outline-none py-2 px-2 text-sm font-normal text-gray-700" v-model="formpass.confirmpass">
                            </div>            
                        </div>
                    </template>
                    <template v-slot:formFooter>
                        <div class="text-primary dark:text-gray-100 font-medium text-lg cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-100 py-2 px-4 rounded" @click="resetmodal = !resetmodal">
                            Cancel
                        </div> 
                        <div class="text-primary dark:text-gray-100 font-medium text-lg cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-100 py-2 px-4 rounded" @click="resetpassword">
                            Save
                        </div>                        
                    </template>
            </FormBase>
        <Transition name="fade">
            <Confirm v-if="deletemodal" @closeconfirm="deletemodal = false">
                <template v-slot:header>
                    Confirm
                </template>
                <template v-slot:main>
                    Are You Sure You Want To Delete This Data ?
                </template>
                <template v-slot:footer>
                    <div class="flex justify-end items-center">
                        <LButton class="bg-gray-300 text-gray-800 mr-2" @click="deletemodal = false">
                            Cancel
                        </LButton>
                        <LButton class="text-white bg-secondary" :class=" isloading ? 'pointer-events-none' : 'cursor-pointer'" :disabled="isloading" @click="deleteData">
                            {{ isloading ? 'Loading...' : 'Confirm' }}
                        </LButton>                            
                    </div>
                </template>
            </Confirm>  
        </Transition>
    </div>
</template>

<script>
import LButton from '../../../layouts/button.vue'
import Confirm from '../../../layouts/confirm.vue'
import FormBase from '../../../layouts/FormBase.vue'
import DataTable from '../../../layouts/DataTable.vue'
export default {
    name: 'PadmawebUserTable',

    data() {
        return {
            resetmodal:false,
            isLoading:false,
            deletemodal: false,
            editIndex : -1,
            deleteID: null,
            form : {
                id: '',
                name: '',
                email: '',
                password : '',
                img: null,
                role_id : ''
            },
           defaultForm : {
                id: '',
                name: '',
                email: '',
                password : '',
                img: null,
                role_id : ''
            },
            headers:[],
            items:[],
            currentPage : 1,
            modal:false,
            roles: [],
            search: '',
            formpass:{
                id:'',
                newpass:'',
                confirmpass:'',
            }
        };
    },

    watch:{
        search:function(){
            if(this.search.length > 0){
                this.searchData(this.search)
            } else {
                this.getData()
            }
            
        },
        modal(val) {
			val || this.clearform();
		},
    },

    mounted() {
        this.getData()
        this.getRole()
        this.getheader()
    },

    methods: {
            getheader(){
            if(this.isDeletePermitted == true || this.isUpdatePermitted == true){
                this.headers = [
                   {
                    Text : 'ID',
                    value : 'id',
                    type: 'string'
                },
                {
                    Text: 'Name',
                    value: 'name',
                    type: 'string'
                },
                {
                    Text: 'Email',
                    value: 'email',
                    type: 'string'
                }
                ,
                 {
                    Text: 'Role',
                    value: 'role_id',
                    type: 'string'
                }
                ,
                {
                    Text: 'Image',
                    value: 'imgpath',
                    type: 'images'
                },
                {
                    Text: 'Actions',
                    action: true,
                }
                ]
            }else{
                this.headers = [
                    {
                    Text : 'ID',
                    value : 'id',
                    type: 'string'
                },
                {
                    Text: 'Name',
                    value: 'name',
                    type: 'string'
                },
                {
                    Text: 'Email',
                    value: 'email',
                    type: 'string'
                }
                ,
                 {
                    Text: 'Role',
                    value: 'role_id',
                    type: 'string'
                }
                ,
                {
                    Text: 'Image',
                    value: 'imgpath',
                    type: 'images'
                }
                ]
            }
        },
        addModal(){
            this.editIndex = -1
            this.modal = !this.modal
        },
        deleteModal(val){
            this.deleteID = JSON.parse(JSON.stringify(val)).item.id
            this.deletemodal = true
        },
        editModal(val){
            this.editIndex = 1
            let obj = JSON.parse(JSON.stringify(val)).item

            this.form.id = obj.id
            this.form.name = obj.name
            this.form.email = obj.email
            this.form.role_id = obj.role_id

            this.modal = true
        },
        resetpass(val){
            this.editIndex = 1
            let obj = JSON.parse(JSON.stringify(val)).item

            this.formpass.id = obj.id
    

            this.resetmodal = true
        },
        getRole(){
            this.axios.defaults.headers.common = { 'Authorization': `Bearer ${this.token}` }
            this.axios.get('api/allroles').then((response) => {
                this.roles = response.data
            }).catch(error => {
               
              console.log(error)

            }).finally(() => {
                this.editIndex = -1
            })
        },
        selectImage(event){
           this.form.img = event.target.files[0];
        },
        changePage(e){
            this.currentPage = e;
            this.getData()
        },

        getData(){
            this.axios.defaults.headers.common = { 'Authorization': `Bearer ${this.token}` }
            this.axios.get(`api/users?page=${this.currentPage}`).then((response) => {
                this.items = response.data
            }).catch(error => {
               
              console.log(error)

            }).finally(() => {
                
            })
        },
        searchData(val){
            this.axios.defaults.headers.common = { 'Authorization': `Bearer ${this.token}` }
            this.axios.get('api/users/search/'+val).then((response) => {
                this.items = response.data
            }).catch(error => {
               
              console.log(error)

            }).finally(() => {
                
            })
        },
        pageChange: function(e){
           this.currentPage = e;
           this.getData()
        },

        clearform: function() {
            this.modal = false
            this.$nextTick(() => {
                this.form = Object.assign({}, this.defaultForm);
                this.editIndex = -1;
            });
        }
           
        ,
        save(){
            if(this.editIndex > -1){
                let formData = new FormData();

                if( this.form.img !== null){
					formData.append('img', this.form.img);
				}
                formData.append('id', this.form.id);
				formData.append('name', this.form.name);
				formData.append('email', this.form.email);
				formData.append('role_id', this.form.role_id);

                    this.axios.defaults.headers.common = { 'Authorization': `Bearer ${this.token}` }
                    this.axios.post('api/users/update',formData).then(() => {
                    this.getData();
                    this.modal = false
                    this.clearform();
                }).catch(error => {                
                    console.log(error)
                }).finally(() => {
                })
            }else{
                let formData = new FormData();
                formData.append('img', this.form.img);		
				formData.append('name', this.form.name);
				formData.append('email', this.form.email);
				formData.append('password', this.form.password);
				formData.append('role_id', this.form.role_id);

                    this.axios.defaults.headers.common = { 'Authorization': `Bearer ${this.token}` }
                    this.axios.post('api/register',formData).then(() => {
                    this.getData();
                    this.clearform()
                }).catch(error => {                
                    console.log(error)
                }).finally(() => {
                })
            }
        },
        deleteData(){
            this.axios.defaults.headers.common = { 'Authorization': `Bearer ${this.token}` }
            this.axios.delete('api/users/'+this.deleteID).then((response) => {
                this.getData()
                this.deleteID = null
                this.deletemodal = false
            }).catch(error => {
               
              console.log(error)

            }).finally(() => {
                
            })
        },

        resetpassword(){
            this.axios.defaults.headers.common = { 'Authorization': `Bearer ${this.token}` }
            this.axios.post('api/resetpassword/change',this.formpass).then((response) => {
                this.getData()
                this.resetmodal = false
                this.formpass = {
                    id:'',
                    newpass:'',
                    confirmpass:'',
                }
                this.$notify({
                    title: "Notification",
                    type: "success",
                    text: "Password Reset Succesfully"
                });
            }).catch(error => {
               
              console.log(error)

            }).finally(() => {
                
            })
        }
    },
    components:{
        DataTable,
        FormBase,
        Confirm,
        LButton
    },
    computed:{
        title(){
            if(this.editIndex > -1){
                return 'Edit Item'
            }else{
                return 'New Item'
            }
        }
    }
};
</script>

<style lang="scss" scoped>

</style>